const NEXO = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10.0001" fill="#3360BE" />
    <path
      d="M6.70948 3.81447L13.4177 7.68564V11.6342L3.15906 5.71134L6.44679 3.81447C6.48714 3.79268 6.53228 3.78128 6.57814 3.78128C6.62399 3.78128 6.66913 3.79268 6.70948 3.81447Z"
      fill="#DDEDFD"
    />
    <path
      d="M13.4178 3.73639L9.99731 5.71069L13.4178 7.68499V3.73639Z"
      fill="#C1DDFC"
    />
    <path
      d="M13.4178 3.73639L16.7083 5.63327C16.7479 5.65734 16.7808 5.69097 16.804 5.73107C16.8272 5.77117 16.8399 5.81646 16.8411 5.86277V13.6051L13.4178 11.6336V3.73639Z"
      fill="#A8CCFA"
    />
    <path
      d="M16.8379 13.6077L13.5501 15.5046C13.5081 15.5288 13.4604 15.5416 13.4119 15.5416C13.3633 15.5416 13.3156 15.5288 13.2736 15.5046L6.56818 11.6334V7.67926L16.8379 13.6077Z"
      fill="#C1DDFC"
    />
    <path
      d="M3.15906 5.71049V13.4528C3.15878 13.5006 3.17086 13.5475 3.19412 13.5892C3.21738 13.6309 3.25103 13.6658 3.29179 13.6906L6.57952 15.5875V7.67926L3.15906 5.71049Z"
      fill="white"
    />
    <path
      d="M6.57953 15.5821L9.99722 13.6078L6.57953 11.6335V15.5821Z"
      fill="#DDEDFD"
    />
  </svg>
);
export default NEXO;
